import AddNewAdditionalInfo from "../addNewAdditionalInfo";
import styles from "./style.module.scss";
import PropTypes from "prop-types";

const CreateNewCreditzForm = ({ values }) => {
  const openVideo = (post) => {
    if (post.trackUrl) {
      window.open(post.trackUrl, "_blank");
    }
  };

  return (
    <div className={styles.CreateNewCreditzContainer}>
      <div className={styles.selectTypeContainer}>
        <div className={styles.selectedType}>
          <div className={styles.select}>
            {values.post.trackName ? "Music" : "Video"}
          </div>
        </div>
      </div>
      <div className={styles.titleContainer}>
        <p className={styles.musicTitle}>
          {values.post.artistName ? `${values.post.artistName}-` : ""}{" "}
          {values.post.trackName || values.post.videoTrackName}
        </p>
        <p className={styles.musicLink} onClick={() => openVideo(values.post)}>
          {values.post.videoTrackName
            ? "Watch on YouTube"
            : "Listen on Spotify"}
        </p>
      </div>
      <div className={styles.MusicBigContainer}>
        <div>
          {values.post.videoTrackName ? (
            <img
              src={values.post.videoImage}
              alt="youtubeVevo"
              style={{ width: 600 }}
            />
          ) : (
            <img
              src={values.post.albumImage}
              alt="spotifyZik"
              style={{ width: 545 }}
            />
          )}
        </div>
      </div>

      <div className={styles.additionalInfos}>
        <div className={styles.title}>Creditz</div>
        {values.post.creditors &&
          values.post.creditors.map((role, index) => (
            <AddNewAdditionalInfo
              key={index}
              role={role.role}
              username={role.username}
            />
          ))}
      </div>
    </div>
  );
};

CreateNewCreditzForm.propTypes = {
  setPublishActive: PropTypes.func
};

CreateNewCreditzForm.defaultProps = {
  values: PropTypes.object,
  setPublishActive: () => {
  },
};

export default CreateNewCreditzForm;
